import React from "react";
import { Modal } from "react-bootstrap";


import { commonErr } from "../../common/errors";

import { LoadingOverlay } from "../../common/loading";
import { MessageLine } from "../../common/messagebox";

// import {  IcCloseOrange} from "../../common/svg";

import { mapSdk } from "../../../model/base";

import CarMapLocation from "./carmaplocation";



class MapBox extends React.Component {
	constructor(props) {
		super(props)
		this.state = {

		}

	
	}		

	close = () => {
		this.props.onHide()
	}

	render() {
		const { title, stype, location } = this.props;

		return (
			<Modal
			show={this.props.show}
			onHide={this.close}
			dialogClassName="modal-l modal-dialog modal-input">
			<Modal.Header closeButton={true} closeLabel={""}>
				<h5>{title}</h5>
			</Modal.Header>
			<Modal.Body>
                <div className="modal-input-body modal-address">
                    <CarMapLocation location={location} mapBox={true} />
                </div>
			</Modal.Body>
		</Modal>
		)
	} 
}

export default MapBox;